function itemSupportsDrag(item) {
  return item.kind === "text" || item.kind === "shape" || item.kind === "legacyCanvasShape" || item.kind === "image" || item.kind === "line" || item.kind === "input";
}

export { itemSupportsDrag };
//# sourceMappingURL=itemSupportsDrag.js.map
